import { render } from "./bond-count.vue?vue&type=template&id=8010b4ca&scoped=true"
import script from "./bond-count.vue?vue&type=script&lang=js"
export * from "./bond-count.vue?vue&type=script&lang=js"

import "./bond-count.vue?vue&type=style&index=0&id=8010b4ca&scoped=scoped&lang=less"

import exportComponent from "D:\\project\\BidData\\code\\xyf_web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8010b4ca"]])

export default __exports__